import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Use demo project ID when emulators are enabled
const USE_EMULATOR = process.env.NEXT_PUBLIC_USE_FIREBASE_EMULATOR === 'true';
const PROJECT_ID = process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'drizl-ca66b';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || 'AIzaSyBtBud7X25pnoypBgCZSKfmak984SARH70',
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || 'drizl-ca66b.firebaseapp.com',
  projectId: PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || 'drizl-ca66b.appspot.com',
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || '413029076926',
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || '1:413029076926:web:c8d68a46eda304a6e073ef',
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || 'G-KNSR4FJSPX',
};


// Initialize Firebase (singleton pattern)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Analytics - only on client side with support check
let analyticsInstance: ReturnType<typeof getAnalytics> | null = null;

export const getAnalyticsInstance = async () => {
  if (typeof window !== 'undefined' && !analyticsInstance) {
    const supported = await isSupported();
    if (supported) {
      analyticsInstance = getAnalytics(app);
    }
  }
  return analyticsInstance;
};

// Development emulators - only connect if explicitly enabled
// USE_EMULATOR already defined at top of file

if (USE_EMULATOR && process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const EMULATOR_HOST = process.env.NEXT_PUBLIC_EMULATOR_HOST || 'localhost';
  
  
  try {
    // Auth emulator - only connect once
    if (!(auth as any).emulatorConfig) {
      connectAuthEmulator(auth, `http://${EMULATOR_HOST}:9099`, {
        disableWarnings: true,
      });
    }
    
    // Firestore emulator - only connect once
    if (!(db as any)._settings.host.includes('localhost')) {
      connectFirestoreEmulator(db, EMULATOR_HOST, 8080);
    }
    
    // Storage emulator - connect without check (handles reconnection internally)
    try {
      connectStorageEmulator(storage, EMULATOR_HOST, 9199);
    } catch {
      // Already connected, ignore
    }
    
    // Functions emulator - improved connection with logging
    try {
      connectFunctionsEmulator(functions, EMULATOR_HOST, 5001);
    } catch {
      // Try to connect anyway, might already be connected
    }
    
  } catch {
  }
} else if (process.env.NODE_ENV === 'development') {
}

export default app;
